import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import IdeaOwner from '../components/IdeaOwner'
import '../components/css/ChatMessage.css'
import * as helpers from '../lib/HelperFunctions'

class CommentSectionChatMessage extends Component {
    render() {
        let date = moment(this.props.timestamp).format('DD.MM.YYYY')
        let time = moment(this.props.timestamp).format('HH:mm')
        let whitespace = "\xa0"

        return (

            <div className='chatContainer'>
                <div className='chatMessageContainer'>
                    <div style={{minWidth: 200 + 'px'}}>
                    <div className='chatImageContainer'>
                        <IdeaOwner
                            ownerName={helpers.trimInitialsName(this.props.fromName)}
                            ownerPhotoURL={helpers.checkImageURL(this.props.fromPhotoURL)}
                        />
                    </div>
                    <div className='senderContainer'>
                        <span className='chatSender' style={{color: 'rgb(100, 100, 100)', font: 'helvetica'}}>{this.props.fromName}</span>
                        <br/>
                        <span className='chatAgo' style={{color: 'rgb(150, 150, 150)', font: 'helvetica'}}> {date} {whitespace} {time}</span>
                    </div>
                    </div>
                    <div className='chatMessage' style={{marginTop: 10 + 'px', color: 'black'}}>
                        {this.props.message}
                    </div>
                </div>

            </div>

        )
    }
}
CommentSectionChatMessage.propTypes = {
    fromName: PropTypes.string.isRequired,
    fromPhotoURL: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    timestamp: PropTypes.number.isRequired,
}

export default CommentSectionChatMessage



// WEBPACK FOOTER //
// ./src/components/CommentSectionChatMessage.js